import { render } from "./LayoutToolbar1.vue?vue&type=template&id=6317f8fb"
import script from "./LayoutToolbar1.vue?vue&type=script&lang=js"
export * from "./LayoutToolbar1.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__